var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeMgt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 14.0302H15.2V15.6382H10.4V10.8141H12V13.009C13.464 11.8271 14.4 10.0261 14.4 8C14.4 4.72764 11.952 2.01809 8.8 1.62412V0C12.84 0.40201 16 3.82714 16 8C16 10.404 14.944 12.5588 13.28 14.0302ZM1.6 8C1.6 5.97387 2.536 4.16482 4 2.99095V5.18593H5.6V0.361809H0.8V1.96985H2.72C1.86528 2.72216 1.18043 3.64938 0.711318 4.68938C0.24221 5.72937 -0.000312848 6.85813 3.02873e-07 8C3.02873e-07 12.1729 3.16 15.598 7.2 16V14.3759C4.048 13.9819 1.6 11.2724 1.6 8ZM11.392 4.87236L6.864 9.42311L4.6 7.14774L3.472 8.28141L6.864 11.6905L12.52 6.00603L11.392 4.87236Z",
    fill: "url(#paint0_linear_421_1806)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_1806",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeMgt);
export default __webpack_public_path__ + "static/media/ChangeMgt.765043750ba3f878429d39852c4dcbfd.svg";
export { ForwardRef as ReactComponent };